import { Component, OnInit } from '@angular/core';
import { PersonalDataService } from '../personal-data.service';
import { UtilitiesService } from '../../../../common/shared/services/utilities.service';
import { Contact } from '../../../../common/models/contact';
import { PreferredContactMethodEnum, PrimaryContactLanguageEnum, OccupationEnum } from '../../../../common/helper/enums';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { PersonalDataFormComponent } from '../personal-data-form/personal-data-form.component';
import { environment } from '../../../../../environments/environment';
import { DialogService } from '../../../../common/shared/services/dialog.service';
import { ChangePasswordComponent } from '../../../../components/handle-user/change-password/change-password.component';
import { ChangeEmailComponent } from '../../../../components/handle-user/change-email/change-email.component';
import { AuthService } from '../../../../common/shared/services/auth.service';

@Component({
  selector: 'app-personal-data-view',
  templateUrl: './personal-data-view.component.html',
  styleUrls: ['./personal-data-view.component.scss']
})
export class PersonalDataViewComponent implements OnInit {

  public contact: Contact;

  PreferredContactMethodEnum: typeof PreferredContactMethodEnum = PreferredContactMethodEnum;
  PrimaryContactLanguageEnum: typeof PrimaryContactLanguageEnum = PrimaryContactLanguageEnum;
  OccupationEnum: typeof OccupationEnum = OccupationEnum;

  constructor(
    private _matDialog: MatDialog,
    private _personalDataService: PersonalDataService,
    private _utilitiesService: UtilitiesService,
    private _translateService: TranslateService,
    private _dialogService: DialogService,
    private _authService: AuthService) { }

  ngOnInit() {
    this._utilitiesService.addMinorAction('LoadContact');
    this.contact = new Contact;
    this.loadContact();
  }

  loadContact() {
    this._personalDataService.loadContact().subscribe(
      data => {
        this.contact = this._utilitiesService.getData(data);

        if (this.contact.primaryContactLanguage === PrimaryContactLanguageEnum.English) {
          this._translateService.use('en');
        }
        this._utilitiesService.removeAction('LoadContact');
      },
      err => {
        this._utilitiesService.handleErrors(err);
      }
    );
  }

  loadContactActive() {
    return this._utilitiesService.isActionActive('LoadContact');
  }

  changePersonalData(area: string) {
    const dialogRef = this._matDialog.open(PersonalDataFormComponent, {
      width: environment.MatDilalogWidth,
      data: {contact: this.contact, area: area}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Success') {
        this.loadContact();
        this._translateService.get(['portal.Profile.PersonalData.Update.Success']).subscribe((res: string) => {
          this._dialogService.showSuccessDialog(res['portal.Profile.PersonalData.Update.Success']);
        });
      } else if (result === 'Error') {
        this._translateService.get(['portal.Profile.PersonalData.Update.Error']).subscribe((res: string) => {
          this._dialogService.showErrorDialogWithBody(res['portal.Profile.PersonalData.Update.Error']);
        });
      }
    });
  }

  changePassword() {
    const dialogRef = this._matDialog.open(ChangePasswordComponent, {
      width: environment.MatDilalogWidth
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Success') {
        this._translateService.get(['portal.Profile.PersonalData.ChangePassword.Success']).subscribe((res: string) => {
          this._dialogService.showSuccessDialogWithCallback(
            this.logout.bind(this),
            res['portal.Profile.PersonalData.ChangePassword.Success']);
        });
      } else if (result === 'Error') {
        this._translateService.get(['portal.Profile.PersonalData.ChangePassword.Error']).subscribe((res: string) => {
          this._dialogService.showErrorDialogWithBody(res['portal.Profile.PersonalData.ChangePassword.Error']);
        });
      }
    });
  }

  changeEmail() {
    const dialogRef = this._matDialog.open(ChangeEmailComponent, {
      width: environment.MatDilalogWidth
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Success') {
        this._translateService.get(['portal.Profile.PersonalData.ChangeEmail.Success']).subscribe((res: string) => {
          this._dialogService.showSuccessDialogWithCallback(
            this.logout.bind(this),
            res['portal.Profile.PersonalData.ChangeEmail.Success']);
        });
      } else if (result === 'Error') {
        this._translateService.get(['portal.Profile.PersonalData.ChangeEmail.Error']).subscribe((res: string) => {
          this._dialogService.showErrorDialogWithBody(res['portal.Profile.PersonalData.ChangeEmail.Error']);
        });
      }
    });
  }

  logout() {
    this._authService.logout();
  }

}
